<template>
  <div class="warp">
    <div id="app">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  /* touch-action: none; */
}
body {
  margin: 0;
  background: rgb(238, 241, 246);
  width: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: relative;
}
.warp {
  width: 100%;
  height: 100%;
  position: relative;
}
p {
  color: #303133;
  font-size: 14px;
}
.p-index .p-index-tabs .el-tabs__content {
  display: none;
}
.p-index-tabs {
  width: 180px;
}
.p-index .p-index-tabs .el-tabs__header {
  float: right;
  margin: 0 2px 0 0;
  padding: 0;
}

.p-index .p-index-tabs .el-tabs__nav-wrap::after {
  background: 0;
}
.p-index .el-input-group__append button.el-button {
  background-color: #409eff;
  color: #fff;
  border-radius: 0 2px 2px 0;
  border: 1px solid #409eff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue